import { useState, useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import WidePopper from '../../util/WidePopper';
import { unique } from '../../../utils/collections';
import { nameValidationMessage } from '../staging';

const NameSelector = ({ name, suggestedName, usedNames, onChange, onBlur, onError }) => {
  const oldName = useMemo(() => name, [name]);
  const [validation, setValidation] = useState(nameValidationMessage(name, oldName, usedNames));
  return (
    <Autocomplete
      PopperComponent={WidePopper}
      options={unique([name, suggestedName].filter(Boolean))}
      freeSolo
      blurOnSelect
      openOnFocus
      autoSelect
      disableClearable
      defaultValue={oldName}
      onInputChange={(event) => {
        const message = nameValidationMessage(event.target.value, name, usedNames);
        if (onError) onError(message);
        return setValidation(message);
      }}
      onBlur={(event) => {
        if (validation === '' && onChange) onChange(event.target.value);
        if (onBlur) onBlur();
      }}
      renderInput={(params) => (
        <TextField
          required
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...params}
          error={validation}
          label={validation}
          name="entityName"
        />
      )}
    />
  );
};

export default NameSelector;
